<script lang="ts">
    import dayjs from 'dayjs';
    import { createEventDispatcher, onMount } from 'svelte';
    import { OverlayScrollbars } from 'overlayscrollbars';

    import { Button, ImagePlaceholder, Divider, Select } from '@allibee/components/basic';

    import { MtmService } from '$lib/api';
    import { PdfViewer } from '@allibee/components/common';
    import { DATE_FORMAT } from '$lib/utils';
    import { _ } from 'svelte-i18n';

    const dispatch = createEventDispatcher();

    export let term: MtmTermSimpleDto;

    let selectedRevisionId: { value: number };
    let revisionOptions: Array<{ label: string; value: number }>;

    let scrollRef: HTMLDivElement;
    let pdf: Blob | null = null;

    const loadPDF = async (revisionId: number) => {
        const res = await MtmService.downloadTermRevision({ termId: term.id, revisionId }, { responseType: 'blob' });
        return new Blob([res.data], { type: 'application/pdf' });
    };

    onMount(async () => {
        revisionOptions = await MtmService.listRevisionOverviews({ id: term.id }).then(res =>
            res.data.data.map(revision => ({
                label: $_('lib.service.term.modalTermRevisionsPreview.labelEffectedRevision', { values: { date: dayjs(revision.effectiveAt).format(DATE_FORMAT.DISPLAY_FULL) } }),
                value: revision.id,
            })),
        );
        selectedRevisionId = { value: term.revisionId };

        pdf = await loadPDF(selectedRevisionId.value);
    });

    $: if (scrollRef) {
        OverlayScrollbars(scrollRef, { scrollbars: { autoHide: 'scroll' } });
    }
</script>

<!-- header 높이 + footer 높이 = 13.8125rem -->
<!-- 모달 사용시 지정해야하는 최대 높이: 80vh -->
<section class="flex h-full w-full flex-col text-center">
    <header class="p-6 text-left text-lg font-semibold text-gray-900">
        {term.title}
    </header>
    <Divider />

    <!-- 최대 높이 도달 시, 내용 높이: 80vh - 13.8125rem -->
    <div class="p-6 text-center">
        <div class="h-[40rem] max-h-[calc(80vh_-_13.8125rem)]">
            {#if pdf}
                {#key pdf}
                    <div bind:this={scrollRef} class="h-full rounded-lg border-2 border-gray-200 text-center" on:wheel|stopPropagation|passive>
                        <PdfViewer contract={pdf} />
                    </div>
                {/key}
            {:else}
                <ImagePlaceholder class="h-full" imgHeight="full" />
            {/if}
        </div>
    </div>

    <Divider />
    <footer class="flex max-w-4xl justify-between rounded-b-lg bg-white p-6">
        <div class="w-[30rem]">
            <Select
                placeholder={revisionOptions ? $_('lib.service.term.modalTermRevisionsPreview.placeholderSelect') : $_('lib.service.term.modalTermRevisionsPreview.placeholderLoading')}
                showChevron
                clearable={false}
                class="text-start"
                bind:value={selectedRevisionId}
                items={revisionOptions}
                loading={!revisionOptions}
                on:change={() => {
                    loadPDF(selectedRevisionId.value).then(res => {
                        pdf = res;
                    });
                }}
            />
        </div>
        <Button on:click={() => dispatch('confirm', true)}>{$_('lib.service.term.modalTermRevisionsPreview.actionConfirm')}</Button>
    </footer>
</section>
